import { motion } from "framer-motion";

export default function ChapterHeading({ eyebrow, title, subtitle, light = false }) {
  return (
    <div className="mb-14 sm:mb-20">
      {eyebrow && (
        <motion.p
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className={`mb-4 font-mono text-xs font-medium uppercase tracking-[0.3em] ${light ? "text-oro" : "text-terracotta"}`}
        >
          {eyebrow}
        </motion.p>
      )}
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className={`mt-5 max-w-2xl text-base font-light leading-relaxed sm:text-lg ${light ? "text-linen/70" : "text-stone-600"}`}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
